// @flow

export default (props) => {
	switch (props.decorator || props.is) {
		case 'ProductListSlider':
			// ESHOP: slider s produkty (odeberte, pokud neni v projektu zapnuta feature productProductRelation ani catalogRecentlyVisitedConfig v ramci catalogTracking feature)
			return import('./components/ProductListSlider');
		case 'EshopPhotogallery':
			// ESHOP: Produktova fotogalerie
			return import('fg-frontend/components/EshopPhotogallery');
		case 'FilterOfFilter':
			return import('./components/FilterOfFilter');
		case 'EshopFulltextAutocomplete':
			// ESHOP: Fulltextovy naseptavac (odeberte, pokud neni povolena fulltext feature)
			return import('./components/EshopFulltextAutocomplete');
		case 'EshopGalleryPopup':
			// ESHOP: Podpora galerie v popupu (odeberte, pokud neni pozadovano chovani galerie v popupu)
			return import('fg-frontend/components/EshopGalleryPopup');
		case 'EshopOrderForm':
			// ESHOP: Podpurna komponenta pro vlozeni zbozi do kosiku (odeberte, pokud nemate v projektu nakupni proces)
			return import('fg-frontend/components/EshopOrderForm');
        case 'ReferenceSelect':
            return import('./components/ReferenceSelect');
		case 'RedirectToUrl':
			// COMMON: Komponenta, ktera zajistuje presmerovani po casovem intervalu (odeberte, pokud nepouzivate zadnou platebni branu)
			return import('fg-frontend/src/components/RedirectToUrl');
		case 'EshopUserToolsHandler':
			// ESHOP: Handler komponenta pro pridani/odebrani produktu z oblibenych/porovnavani
			return import('./components/EshopUserToolsHandler');
		case 'EshopCategorySubcategories':
			// ESHOP: Komponenta pro zobrazeni podkategorii
			return import('./components/EshopCategorySubcategories');
		// case 'BranchPicker':
			// ESHOP: Komponenta pro vyber pobocky v ramci vybranych doprav (odeberte, pokud neni na widgetu pro vyber dopravy nastavene metadato <enableBranchPicker>true</enableBranchPicker>)
			// return import('fg-frontend/src/components/BranchPicker');
		case 'Form':
			// COMMON: Komponenta pro osetreni HTML formu (odeberte, pokud nepouzivate vyber variant ve vypisu produktu ani objednavkovy pruvodce)
			return import('fg-frontend/src/components/Form');
	}
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureEshopComponents.js